import { useState, useEffect } from "react";
import { useColors } from "../ColorsContext";
import WristbandIcon from "../components/WristbandIcon";

export default function ScreenAttract({ path, checkpoint, onActivate, onBack, layout }) {
  const C = useColors();
  const [pulse, setPulse] = useState(true);
  const [bounce, setBounce] = useState(false);
  const { scale = 1, offsetX = 0, vpWidth = 390 } = layout || {};
  const extraLeft = offsetX / scale;

  useEffect(() => {
    const t1 = setInterval(() => setPulse(p => !p), 1000);
    const t2 = setInterval(() => {
      setBounce(true);
      setTimeout(() => setBounce(false), 400);
    }, 2000);
    return () => { clearInterval(t1); clearInterval(t2); };
  }, []);

  return (
    <div
      onClick={onActivate}
      style={{
        height: "100%", display: "flex", flexDirection: "column",
        alignItems: "center", justifyContent: "center",
        background: C.navy, cursor: "pointer",
        position: "relative", padding: 28,
      }}
    >
      {/* Full-width animated border */}
      <div style={{
        position: "absolute", top: 0, bottom: 0,
        left: -extraLeft, width: vpWidth / scale,
        boxShadow: `inset 0 0 0 ${pulse ? 4 : 3}px ${path.color}`,
        transition: "box-shadow 1s ease",
        pointerEvents: "none", zIndex: 5,
      }} />

      {/* Back button — stop propagation so tap doesn't trigger onActivate */}
      <button
        onClick={e => { e.stopPropagation(); onBack(); }}
        style={{
          position: "absolute", top: 14, left: 14,
          background: "rgba(0,0,0,0.35)", border: "none",
          color: C.muted, fontSize: 17, cursor: "pointer",
          padding: "6px 12px", borderRadius: 6, zIndex: 10,
          fontFamily: "inherit",
        }}
      >← Back</button>

      {/* Corner accents — stretch to full viewport width */}
      {[
        { top: 0, left: -extraLeft, borderTop: `3px solid ${path.color}`, borderLeft: `3px solid ${path.color}` },
        { top: 0, right: -extraLeft, borderTop: `3px solid ${path.color}`, borderRight: `3px solid ${path.color}` },
        { bottom: 0, left: -extraLeft, borderBottom: `3px solid ${path.color}`, borderLeft: `3px solid ${path.color}` },
        { bottom: 0, right: -extraLeft, borderBottom: `3px solid ${path.color}`, borderRight: `3px solid ${path.color}` },
      ].map((style, i) => (
        <div key={i} style={{ position: "absolute", width: 20, height: 20, ...style }} />
      ))}

      {/* Path badge */}
      <div style={{
        background: `${path.color}22`, border: `1px solid ${path.color}`,
        borderRadius: 20, padding: "4px 14px", fontSize: 11, color: path.color,
        fontWeight: 700, letterSpacing: 2, marginBottom: 20,
      }}>
        {path.label.toUpperCase()}
      </div>

      {/* Obstacle icon & name */}
      <div style={{ fontSize: 40, marginBottom: 10 }}>
        {["🧗", "🪜", "🔩", "🏋️", "🧱", "🏖️"][checkpoint.id - 1] || "⚡"}
      </div>
      <div style={{ fontSize: 22, fontWeight: 900, color: C.white, textAlign: "center", marginBottom: 8 }}>
        {checkpoint.obstacle.toUpperCase()}
      </div>

      {/* Narrative teaser */}
      <div style={{
        fontSize: 13, color: C.light, textAlign: "center", lineHeight: 1.6,
        marginBottom: 32, opacity: 0.85, maxWidth: 280, fontStyle: "italic",
      }}>
        "{checkpoint.story[path.id]}"
      </div>

      {/* Animated CTA */}
      <div style={{
        display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
        transform: bounce ? "translateY(-6px)" : "translateY(0)",
        transition: "transform 0.4s ease",
      }}>
        <div style={{
          background: path.color, borderRadius: 10, padding: "14px 28px",
          display: "flex", alignItems: "center", gap: 10,
          boxShadow: `0 0 20px ${path.color}60`,
        }}>
          <WristbandIcon size={20} color="#fff" />
          <span style={{ fontWeight: 800, color: "#fff", fontSize: 14, letterSpacing: 0.5 }}>
            SCAN WRISTBAND TO BEGIN
          </span>
        </div>
        <div style={{ fontSize: 11, color: C.muted }}>or tap anywhere on this screen</div>
      </div>

      {/* Pulse ring */}
      <div style={{
        position: "absolute",
        width: pulse ? 320 : 230, height: pulse ? 58 : 58,
        borderRadius: 14, border: `1px solid ${path.color}`,
        opacity: pulse ? 0.30 : 0, transition: "all 1s ease",
        pointerEvents: "none", bottom: 238,
      }} />

      {/* Checkpoint badge */}
      <div style={{ position: "absolute", bottom: 20, right: 20, fontSize: 10, color: C.muted, letterSpacing: 1 }}>
        CP {checkpoint.id} / 6
      </div>
    </div>
  );
}
